/*
 * @Author       : 程哲林
 * @Date         : 2023-01-17 21:57:03
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-01-17 21:59:59
 * @FilePath     : /marketing-landing-fe/src/const/mock.ts
 * @Description  : 未添加文件描述
 */
export default {
  '/common/getCurrentIpAddress': '/noRight/common/getCurrentIpAddress'
};